import React from 'react';
import {
  RefreshCw, Sparkles, UserCheck, StickyNote, Paperclip, Handshake,
  ClipboardList, Mail, CheckSquare, Zap, DollarSign,
} from 'lucide-react';
import { formatDate } from '../crmConstants';

const TYPE_CONFIG = {
  stage_changed: { icon: RefreshCw, color: '#3B82F6', bg: '#EFF6FF' },
  deal_created: { icon: Sparkles, color: '#F59E0B', bg: '#FFFBEB' },
  deal_assigned: { icon: UserCheck, color: '#8B5CF6', bg: '#F5F3FF' },
  note_added: { icon: StickyNote, color: '#10B981', bg: '#ECFDF5' },
  document_uploaded: { icon: Paperclip, color: '#06B6D4', bg: '#ECFEFF' },
  team_invite: { icon: Handshake, color: '#EC4899', bg: '#FDF2F8' },
  email_sent: { icon: Mail, color: '#0078D4', bg: '#E5F2FF' },
  email_connected: { icon: Mail, color: '#10B981', bg: '#ECFDF5' },
  task_created: { icon: CheckSquare, color: '#8B5CF6', bg: '#F5F3FF' },
  task_completed: { icon: CheckSquare, color: '#10B981', bg: '#ECFDF5' },
  sequence_enrolled: { icon: Zap, color: '#F59E0B', bg: '#FFFBEB' },
  sequence_unenrolled: { icon: Zap, color: '#6B7280', bg: '#F3F4F6' },
  sequence_email_sent: { icon: Zap, color: '#10B981', bg: '#ECFDF5' },
  rates_updated: { icon: DollarSign, color: '#F59E0B', bg: '#FFFBEB' },
  commission_update: { icon: DollarSign, color: '#8B5CF6', bg: '#F5F3FF' },
  default: { icon: ClipboardList, color: '#6B7280', bg: '#F3F4F6' },
};

export const ActivityFeed = ({ activities }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
    {activities.length === 0 ? (
      <p style={{ textAlign: 'center', padding: '2rem', color: '#9CA3AF' }}>No recent activity</p>
    ) : activities.map((a, i) => {
      const config = TYPE_CONFIG[a.type] || TYPE_CONFIG.default;
      const IconComponent = config.icon;
      return (
        <div key={a.id || `activity-${a.timestamp}-${i}`} style={{
          display: 'flex', alignItems: 'flex-start', gap: '0.75rem', padding: '0.875rem 1rem',
          background: '#fff', borderRadius: 8, border: '1px solid #E5E7EB',
        }} data-testid={`activity-${i}`}>
          <div style={{
            width: 32, height: 32, borderRadius: '50%', background: config.bg,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <IconComponent size={16} style={{ color: config.color }} />
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: '0.875rem', fontWeight: 500, color: 'var(--navy)' }}>{a.description}</div>
            <div style={{ fontSize: '0.75rem', color: '#9CA3AF' }}>
              {a.actor_name} • {formatDate(a.timestamp)}
            </div>
          </div>
        </div>
      );
    })}
  </div>
);
